module.exports = __webpack_public_path__ + "img/gilly_weed.dd2b9a11.jpg";